/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import CampaignModel from 'cio/models/campaign';
import CustomerModel from 'cio/models/customer';
import SubjectModel from 'cio/models/subject';
import AuthService from 'cio/services/auth';

interface JourneysTableRowArgs {
  subject: SubjectModel;
  customer?: CustomerModel;
  campaign?: CampaignModel;
}

export default class JourneysTableRow extends Component<JourneysTableRowArgs> {
  @service auth!: AuthService;

  // Temporary fix for https://github.com/customerio/opsbugs/issues/3543
  get nextAction() {
    return this.args.subject.belongsTo('nextAction').value();
  }

  get firstColumnType() {
    if (this.args.campaign != null) {
      if (this.args.campaign.isWebhookTriggered) {
        return 'webhook';
      }

      return 'person';
    }

    if (this.args.customer != null) {
      return 'campaign';
    }

    return null;
  }

  get canLinkToJourney() {
    if (this.firstColumnType === 'person' || this.firstColumnType === 'campaign') {
      let customer = this.args.subject.belongsTo('customer').value();
      return customer != null;
    }

    if (this.firstColumnType === 'webhook') {
      return true;
    }

    return false;
  }

  get journeyLinkRoute() {
    if (this.firstColumnType === 'person' || this.firstColumnType === 'campaign') {
      return 'person.subjects.subject';
    }

    if (this.firstColumnType === 'webhook') {
      return 'campaigns.campaign.overview.subjects.subject';
    }

    return null;
  }

  get journeyLinkModels() {
    if (this.firstColumnType === 'person' || this.firstColumnType === 'campaign') {
      return [this.customerId, this.args.subject.id];
    }

    if (this.firstColumnType === 'webhook') {
      return [this.args.campaign?.id, this.args.subject.id];
    }

    return null;
  }

  get customerExists() {
    if (this.args.campaign == null) {
      return true;
    }

    let customer = this.args.subject.belongsTo('customer').value();

    return customer != null;
  }

  get customerId() {
    return this.args.subject.belongsTo('customer').id();
  }

  get hasReadOnlyPermission() {
    if (this.args.campaign != null) {
      if (this.args.campaign.isApiTriggered) {
        return !this.auth.hasPermission('journeys/broadcasts/edit');
      }

      return !this.auth.hasPermission('journeys/campaigns/edit');
    }

    return true;
  }
}
